(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  const screen = window.matchMedia('(min-width: 750px)');
  const excluded = '.qeydo-context-copy,.rte,.section-rte,.qp-document,dialog,.modal,.card,.qc-guide-card,.qp-story-card,.qpx-card,.product__info-container';
  const captions = 'p:not(.subtitle),.section-rte,.description,[class$="__text"],[class$="__description"],[class$="__intro-text"],[class$="__lede"],[class$="__intro"]';
  const headingGroups = '.titles,.qc-heading,.title-wrapper,.title-wrapper-with-link';
  const pageHeads = '.qc-intro-copy,.qc-intro-grid,.qeydo-collection-intro,[class*="hero"],.main-page-title,.main-collection-banner';
  let pairs = [], frame, observer;
  const styled = new Set();
  function reset(node) {
    node.removeAttribute('data-qeydo-caption-fit');
    node.style.removeProperty('--qeydo-caption-width');
  }
  function discover() {
    observer?.disconnect();
    for (const node of styled) reset(node);
    styled.clear();
    const containers = new Set();
    const firstSection = root.querySelector(':scope > .shopify-section');
    const pageSections = new Set([...root.querySelectorAll('h1')].map(heading => heading.closest('.shopify-section')).filter(Boolean));
    pairs = [];
    for (const heading of root.querySelectorAll('h1,h2,.titles>:is(h3,h4,h5,h6),.qc-heading>:is(h3,h4,h5,h6)')) {
      const section = heading.closest('.shopify-section');
      // A page masthead keeps its approved column width, irrespective of title length.
      if (heading.tagName === 'H1' || heading.closest(pageHeads) || heading.closest(excluded)) continue;
      if (section && (section === firstSection || pageSections.has(section))) continue;
      const targets = new Set();
      let sibling = heading.nextElementSibling;
      // Only introductory text adjoining a primary heading, never cards, buttons or data tables.
      while (sibling && sibling.matches(captions) && !sibling.querySelector('h1,h2,h3,form,table,button,.button')) {
        targets.add(sibling);
        sibling = sibling.nextElementSibling;
      }
      const group = heading.closest(headingGroups) || heading.parentElement;
      if (group.matches(headingGroups)) {
        const following = group.nextElementSibling || group.parentElement?.nextElementSibling;
        if (following?.matches('.description,.qp-document--description')) {
          targets.add(following.matches('.container') ? following.querySelector('.section-rte,.description') || following : following);
        }
      }
      if (!targets.size) continue;
      pairs.push({heading, targets});
      containers.add(group.parentElement || group);
    }
    if ('ResizeObserver' in window) {
      const widths = new WeakMap();
      observer = new ResizeObserver(entries => {
        let changed = false;
        for (const entry of entries) {
          const width = entry.contentRect.width;
          if (widths.get(entry.target) !== width) { widths.set(entry.target, width); changed = true; }
        }
        if (changed) schedule();
      });
      for (const container of containers) observer.observe(container);
    }
    schedule();
  }
  function textWidth(heading) {
    const lines = [];
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    const range = document.createRange();
    let node;
    while ((node = walker.nextNode())) {
      if (!node.textContent.trim()) continue;
      range.selectNodeContents(node);
      for (const rect of range.getClientRects()) {
        if (!rect.width || !rect.height) continue;
        let line = lines.find(item => Math.abs(item.top - rect.top) < Math.min(item.height, rect.height) / 2);
        if (!line) { line = {top: rect.top, height: rect.height, left: rect.left, right: rect.right}; lines.push(line); }
        else { line.left = Math.min(line.left, rect.left); line.right = Math.max(line.right, rect.right); }
      }
    }
    return Math.ceil(Math.max(0, ...lines.map(line => line.right - line.left)));
  }
  function update() {
    if (!screen.matches) {
      for (const node of styled) reset(node);
      styled.clear();
      return;
    }
    // Batch all geometry reads before changing any caption width.
    const changes = [];
    for (const {heading, targets} of pairs) {
      if (!heading.isConnected) continue;
      const width = textWidth(heading);
      if (width < 1) continue;
      for (const target of targets) {
        const align = getComputedStyle(target).textAlign;
        changes.push({target, width, align: align === 'center' ? 'center' : align === 'right' ? 'right' : 'left'});
      }
    }
    for (const {target, width, align} of changes) {
      target.style.setProperty('--qeydo-caption-width', `${width}px`);
      target.setAttribute('data-qeydo-caption-fit', align);
      styled.add(target);
    }
  }
  function schedule() { window.cancelAnimationFrame(frame); frame = window.requestAnimationFrame(update); }
  window.addEventListener('resize', schedule, {passive: true});
  screen.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', discover);
  if (document.fonts) {
    document.fonts.ready.then(schedule);
    document.fonts.addEventListener?.('loadingdone', schedule);
  }
  discover();
})();
